/** Energy — sub-metering /energy/sub-metering (subMetering.vue + TreeNode.vue) */
export default {
  subMeteringPage: {
    emptyNoViewPermission: 'No permission to view',
    phSearchKeyword: 'Search by name / serial…',
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    titleUndo: 'Undo reorder/move (up to 5 steps)',
    btnUndo: 'Undo',
    titleRefresh: 'Refresh topology',
    btnRefresh: 'Refresh',
    msgSankeyDev: 'Sankey diagram is under development',
    btnSankey: 'Sankey',
    titleZoomOut: 'Zoom out',
    titleZoomIn: 'Zoom in',
    titleResetView: 'Reset view',
    emptyNoTopology: 'No topology data',
    btnCreateRoot: 'Create root',
    titleClosePanel: 'Close',
    dateRangeTo: 'to',
    altMeter: 'Meter',
    altMainMeter: 'Primary',
    altBackupMeter: 'Backup',
    ehcLabelTotalEnergy: 'Period total energy',
    childEnergyTitle: 'Child energy ranking',
    childCountLabel: '{n} nodes',
    labelPrimaryShort: 'M',
    labelBackupShort: 'B',
    labelPrimary: 'Pri',
    labelBackup: 'Bak',
    labelCategoryNode: 'Category',
    labelDualPower: 'Dual supply',
    labelDualPowerNode: 'Dual-supply node',
    emptyNoChildren: 'No child nodes. Right-click to add.',
    chartDailyTrend: 'Daily energy trend',
    chartUnitKwh: 'Energy (kWh)',
    chartLegendTotal: 'Total energy',
    emptyNoDailyData: 'No daily energy data',
    statPeakDaily: 'Peak daily energy',
    statAvgDaily: 'Average daily energy',
    statLossRate: 'Line loss',
    statDeviceCount: 'Devices',
    unitDevice: 'ea.',
    sectionUpstreamMeter: 'Upstream meter',
    linkViewDetail: 'Details',
    linkView: 'View',
    labelMainMeter: 'Primary meter',
    labelBackupMeter: 'Backup meter',
    labelLossRateInline: 'Line loss',
    ratioPrefix: 'Share',
    tagCurrentNode: 'Current node',
    labelTotalEnergy: 'Total {v} kWh',
    labelRealtimePower: 'Real-time power {v} kW',
    dualSepBackup: 'Backup meter',
    sectionDownstreamMeter: 'Downstream meters',
    draggingMoving: 'Moving:',
    dlgBindMeter: 'Bind meter',
    dlgBindDual: 'Bind meters (dual supply)',
    dualDlgAlert: 'Select two meters as primary and backup (first = primary, second = backup).',
    phMeterSearch: 'Search serial / name',
    colSerial: 'Serial',
    colMeterName: 'Name',
    colMeterType: 'Meter type',
    colOnlineStatus: 'Online',
    btnConfirmBind: 'Bind',
    btnOk: 'OK',
    btnCancel: 'Cancel',
    dualSelectedPrefix: 'Selected {n}/2:',
    dlgLayerSettings: 'Layer settings',
    formLayerName: 'Layer name',
    phLayerName: 'Enter layer name',
    btnConfirmAdd: 'Add',
    virtualRootName: 'Project root',
    nodeTypeRoot: 'Root',
    nodeTypeCategory: 'Category',
    nodeTypeDual: 'Dual-supply device',
    nodeTypeDevice: 'Device',
    treeExpand: 'Expand',
    treeCollapse: 'Collapse',
    treeExpandChildren: 'Expand {n} nodes',
    treeExpandHidden: 'Expand {n} hidden',
    placeholderChildDevice: 'Child {n}',
    meterBind_1: 'Dedicated',
    meterBind_2: 'Shared',
    meterBind_3: 'Formula',
    meterBind_4: 'HVAC',
    meterOnline_0: 'Offline',
    meterOnline_1: 'Online',
    msgNoControl: 'No control permission',
    msgFetchTreeFail: 'Failed to load topology',
    msgLoadMeterListFail: 'Failed to load meter list',
    ctxAddRoot: 'Add root',
    ctxAddCategory: 'Add subcategory',
    ctxBindMeter: 'Bind meter',
    ctxBindDual: 'Bind (dual supply)',
    ctxRename: 'Rename',
    ctxDelete: 'Delete node',
    ctxUnbind: 'Unbind',
    promptAddCatTitle: 'New subcategory',
    promptAddCatMessage: 'Subcategory name',
    promptRenameTitle: 'Rename',
    promptRenameMessage: 'New name',
    inputErrorNameRequired: 'Name is required',
    msgCreateSuccess: 'Created: {name}',
    msgCreateFail: 'Create failed',
    msgCreateFailRetry: 'Create failed, try again',
    msgRenameSuccess: 'Renamed',
    msgRenameFail: 'Rename failed',
    msgRenameFailRetry: 'Rename failed, try again',
    titleWarning: 'Warning',
    confirmDeleteWithChildren: 'Delete “{name}” and all children?',
    confirmUnbind: 'Unbind “{name}”?',
    msgDeleteSuccess: 'Deleted',
    msgUnbindSuccess: 'Unbound',
    msgDeleteFail: 'Delete failed',
    msgUnbindFail: 'Unbind failed',
    msgOpFailRetry: 'Operation failed, try again',
    msgPickTwoMeters: 'Select two meters (primary and backup)',
    msgBindDualSuccess: 'Dual supply bound',
    msgBindFail: 'Bind failed',
    msgBindFailRetry: 'Bind failed, try again',
    msgPickAtLeastOneMeter: 'Select at least one meter',
    msgBindManySuccess: 'Bound {n} meter(s)',
    msgBindPartial: '{ok} succeeded, {fail} failed',
    msgLayerNameRequired: 'Enter layer name',
    msgOnlyOneRoot: 'Only one root at the top level',
    msgLayerAdded: 'Layer added: {name}',
    msgAddFail: 'Add failed',
    msgAddFailRetry: 'Add failed, try again',
    msgCannotMoveToDescendant: 'Cannot move under own descendant',
    msgMoveSuccess: 'Moved',
    msgMoveFail: 'Move failed',
    msgMoveFailRetry: 'Move failed, try again',
    msgSortSuccess: 'Order updated',
    msgOpFail: 'Operation failed',
    msgOpFailRetry2: 'Operation failed, try again',
    msgUndoNone: 'Nothing to undo (max {max} steps)',
    msgUndoSyncing: 'Undoing, syncing {n} node(s)…',
    msgUndoPartialFail: 'Partial undo failed ({fail}/{total} nodes)',
    msgUndoSuccess: 'Undone',
    msgDailyEnergyFail: 'Failed to load daily energy',
    msgDailyEnergyFailRetry: 'Failed to load daily energy',
    msgDateSpanYear: 'Date range cannot exceed one year',
    msgQueriedRange: 'Queried {start} – {end}',
    msgViewInfo: 'View: {name}'
  }
}
